
import "/home/runner/work/legacy-av-bms-crm-web-v2-reactjs/legacy-av-bms-crm-web-v2-reactjs/src/components/HeaderDropdown/index.less?modules";
export default {"container": `container-uLzrBsJB`}
